import React, { useState, useEffect } from "react";
import EmployeeListTable from "./components/EmployeeListTable";
import Filter from "./modals/Filter";
import Edit from "./modals/Edit";
import Divider from "@material-ui/core/Divider";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import axios from "axios";
import { v4 as uuid } from "uuid";
import ExportModal from "./modals/ExportModal";
import { updateObject } from "../../../helpers/updateObject";

export default function EmployeeList() {
  const [showFilter, setShowFilter] = React.useState(false);

  function handleChange() {
    setShowFilter((key) => !key);
  }

  const [showEdit, setShowEdit] = useState(false);
  const [showView, setShowView] = React.useState(false);
  const [error, setError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [sortField, setSortField] = useState("id");
  const [orderBy, setOrderBy] = useState(false);
  const [rows, setRows] = useState([]);
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [count, setCount] = useState(0);
  const [deleteEmployeeListsIds, setDeleteEmployeeListsIds] = useState([]);
  const [filter, setFilter] = useState(false);

  const [assets, setAssets] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [exportParcent, setExportParcent] = useState(0);
  const [assetId, setAssetId] = useState("")
  // const [chooseLoaded, setChooseLoaded] = useState(false)


  const [employeeList, setEmployeeList] = useState({});
  // const [grades, setGrades] = useState([]);


  const [filterInputs, setFilterInputs] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    assetName: "",
    isActive: ""
  });

  const onEmployeeLists = (skip, take, sortField, orderBy) => {
    setIsLoaded(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}employee/forAdmin?Skip=${skip}&Take=${take}&SortField=${sortField}&OrderBy=${orderBy}`,
        {
          headers: {
            "Accept-Language": 1,
          },
        }
      )
      .then(
        ({ data: { data, totalCount } }) => {
          setIsLoaded(false);
          setRows(data);
          setCount(totalCount);
          setError(false);
        }
      ).catch((error) => {
        setIsLoaded(false);
        setError(true);
        setRows([]);
        setCount(0);
      });
  };
  const onFilter = (skip, take, sortField, orderBy, filterInputs) => {
    setIsLoaded(true);
    const { fullName, email, phoneNumber, assetName, isActive } = filterInputs;
    axios
      .get(
        `${process.env.REACT_APP_API_URL}employee/filter/admin?Skip=${skip}&Take=${take}&SortField=${sortField}&OrderBy=${orderBy}&FullName=${fullName}&Email=${email}&PhoneNumber=${phoneNumber}&AssetName=${assetName}&IsActive=${isActive}`,
        {
          headers: {
            "Accept-Language": 1,
          },
        }
      )
      .then(
        ({ data: { data, totalCount } }) => {
          setIsLoaded(false);
          setRows(data);
          setCount(totalCount);
          setError(false);
        },
        (error) => {
          setIsLoaded(false);
          setError(true);
          setRows([]);
          setCount(0);
        }
      );
  };


  // const onGrades = () => {
  //   axios
  //     .get(`${process.env.REACT_APP_API_URL}grades`, {
  //       headers: {
  //         "Accept-Language": 1,
  //       },
  //     })
  //     .then(({ data: { data } }) => {
  //       setGrades(data);
  //     });
  // };

  // useEffect(() => {
  //   onGrades();
  // }, []);


  const onEmployeeListChoose = (id) => {
    // setChooseLoaded(true)
    axios
      .get(`${process.env.REACT_APP_API_URL}employee/${id}`)
      .then(({ data }) => {
        setEmployeeList(data);
        // setChooseLoaded(false)
      });
  };

  const onUpdateUserStatus = (id, statusType) => {
    let isActive = !statusType;
    axios
      .patch(
        `${process.env.REACT_APP_API_URL}employee/active`,
        {
          id,
          isActive,
        },
        {
          headers: {
            "x-requestid": uuid(),
          },
        }
      )
      .then(() => {
        onEmployeeLists(skip, take, sortField, orderBy);
      });
  };

  const onDeleteEmployeeLists = () => {
    axios
      .delete(`${process.env.REACT_APP_API_URL}employee`, {
        headers: {
          "x-requestid": uuid(),
        },
        data: {
          id: deleteEmployeeListsIds,
        },
      })
      .then((res) => {
        setDeleteEmployeeListsIds([]);
        onEmployeeLists(skip, take, sortField, orderBy);
      });
  };

  const filterInputsUpdate = (e) => {
    const updateFiltersInput = updateObject(filterInputs, {
      [e.target.name]: e.target.value,
    });

    setFilterInputs(updateFiltersInput);
    setSkip(0);
    setFilter(true);
  };

  const onAssets = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}asset`, {
        headers: {
          "Accept-Language": 1,
        },
      })
      .then(({ data: { data } }) => {
        setAssets(data);
      });
  };


  useEffect(() => {
    onAssets();
  }, []);



  useEffect(() => {
    if (filter) {
      const timer = setTimeout(() => {
        onFilter(skip, take, sortField, orderBy, filterInputs);
      }, 500);

      return () => clearTimeout(timer);
    } else {
      onEmployeeLists(skip, take, sortField, orderBy);
    }
  }, [skip, take, sortField, orderBy, filter, filterInputs]);


  useEffect(() => {
    if (!showView || !showEdit) setEmployeeList({});
  }, [showView, showEdit]);


  const onEmployeeListsExport = () => {
    setExportLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}employee/export/admin?assetId=${assetId}`, {
        responseType: "blob",

        onDownloadProgress: (progressEvent) => {
          setExportLoading(false);
          const size = progressEvent.total;
          const current = progressEvent.loaded;

          let percentCompleted = Math.floor((current / size) * 100);
          setExportParcent(percentCompleted);
        },
      })
      .then((res) => {
        var url = window.URL.createObjectURL(new Blob([res.data]));
        var a = document.createElement("a");
        a.href = url;
        a.download = "EmployeeList.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
      });
  };

  return (
    <div className="row bg-white rounded">
      <div className="col-12 d-flex align-items-center py-4 fixed-title">
        <h1 className="display-4 mb-0">Employee </h1>
        <FormControlLabel
          control={
            <Switch
              checked={showFilter}
              onChange={handleChange}
              color="secondary"
            />
          }
          label={showFilter ? "Hide filter" : "Show filter"}
          className="ml-auto mb-0"
        />
      </div>
      <Divider className="w-100" />
      <EmployeeListTable
        setSortField={setSortField}
        setOrderByTable={setOrderBy}
        sortField={sortField}
        orderBy={orderBy}
        isLoaded={isLoaded}
        error={error}
        rows={rows}
        updateSkip={setSkip}
        updateTake={setTake}
        count={count}
        onUpdateUserStatus={onUpdateUserStatus}
        setDeleteEmployeeListsID={setDeleteEmployeeListsIds}
        deleteEmployeeListsIds={deleteEmployeeListsIds}
        onDeleteEmployeeLists={onDeleteEmployeeLists}
        onEmployeeListsExport={onEmployeeListsExport}
        setModalShow={setModalShow}
        setOpenEdit={setShowEdit}
        onEmployeeListChoose={onEmployeeListChoose}


      />
      <Filter
        show={showFilter}
        onHide={handleChange}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
      />

      <Edit
        employeeList={employeeList}
        show={showEdit}
        onHide={setShowEdit}
        skip={skip}
        take={take}
        sortField={sortField}
        orderBy={orderBy}
        onEmployeeLists={onEmployeeLists}
        // grades={grades}
      />

      <ExportModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        onExport={onEmployeeListsExport}
        exportLoaded={exportLoading}
        exportParcent={exportParcent}
        assets={assets}
        setAssetId={setAssetId}
        assetId={assetId}
      />
    </div>
  );
}
